import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import * as am5radar from '@amcharts/amcharts5/radar';
import { CheckBrowserChartService } from '@app/core/services/check-browser-chart.service';
import { Transaction } from '@app/transactions/transaction';
import { System } from '@app/core/resources/system';

@Component({
    selector: 'app-gradient-system',
    templateUrl: './gradient-system.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./gradient-system.component.scss']
})
export class GradientSystemComponent implements OnInit {
    @Input() public valueTrend: number = 0;
    @Input() public valueVolume: number = 0;
    @Input() public system: System = new System();
    public transaction: Transaction = new Transaction();
    public valueText: string = '';
    public dateNow: string = '';
    private colorGraph: Array<{ [key: string]: any }> = [
        { color: am5.color(0x00cc99) },
        { color: am5.color(0xffca28) },
        { color: am5.color(0x00cc99) }
    ];

    private colorVolumeGraph: Array<{ [key: string]: any }> = [{ color: am5.color(0xffffff) }, { color: am5.color(0xfa3316) }];

    public constructor(private checkBrowserService: CheckBrowserChartService) {}

    public ngOnInit(): void {
        this.setValueBuyOrSell();
        let minutes: number = new Date().getMinutes();
        if (minutes < 60) {
            this.dateNow = minutes + (minutes === 1 ? ' minuto' : ' minutos');
        } else {
            let hours: number = Math.floor(minutes / 60);
            this.dateNow = hours + (hours === 1 ? ' hora' : ' horas');
        }
        this.checkBrowserService.browserOnly(() => {
            let rootTrend: am5.Root = am5.Root.new('chartTrend');
            let rootVolume: am5.Root = am5.Root.new('chartVolume');

            this.setChart(rootTrend, 180, 360, -1, 1, this.valueTrend, this.colorGraph);
            this.setChart(rootVolume, 180, 300, 0, 100, 89, this.colorVolumeGraph);
        });
    }

    public setChart(root: am5.Root, startAngle: number, endAngle: number, min: number, max: number, valueGraph: number, color: any): void {
        root.setThemes([am5themes_Animated.new(root)]);

        let chart: am5radar.RadarChart = root.container.children.push(
            am5radar.RadarChart.new(root, {
                panX: false,
                panY: false,
                startAngle: startAngle,
                endAngle: endAngle
            })
        );

        let axisRenderer: am5radar.AxisRendererCircular = am5radar.AxisRendererCircular.new(root, {
            innerRadius: -10,
            strokeOpacity: 1,
            strokeWidth: 10,
            showTooltipOn: 'hover',
            strokeGradient: am5.LinearGradient.new(root, {
                rotation: 0,
                stops: color
            })
        });

        axisRenderer.ticks.template.setAll({
            visible: false,
            strokeOpacity: 0.1
        });

        let xAxis: am5xy.ValueAxis<am5xy.AxisRenderer> = chart.xAxes.push(
            am5xy.ValueAxis.new(root, {
                maxDeviation: 0,
                min: min,
                max: max,
                strictMinMax: true,
                renderer: axisRenderer
            })
        );

        let legend: am5.Legend = chart.children.push(am5.Legend.new(root, {}));
        legend.valueLabels.template.set('forceHidden', true);

        let axisDataItem: am5.DataItem<am5xy.IValueAxisDataItem> = xAxis.makeDataItem({});
        axisDataItem.set('value', 0);

        axisDataItem.set(
            'bullet',
            am5xy.AxisBullet.new(root, {
                sprite: am5radar.ClockHand.new(root, {
                    radius: am5.percent(95),
                    innerRadius: 0,
                    pinRadius: 6,
                    topWidth: 1,
                    bottomWidth: 5
                })
            })
        );

        xAxis.get('renderer').labels.template.setAll({
            visible: false
        });

        xAxis.createAxisRange(axisDataItem);

        setInterval(() => {
            axisDataItem.animate({
                key: 'value',
                to: valueGraph,
                duration: 800,
                easing: am5.ease.out(am5.ease.cubic)
            });
        }, 2000);
    }

    public setValueBuyOrSell(): void {
        switch (true) {
            case this.system.attributes.trend < 0:
                this.valueText = 'Comprar';
                this.transaction.attributes.system1 = this.system.id === 'banco' ? 'palpal' : 'banco';
                this.transaction.attributes.system2 = this.system.id;

                return;
            case this.system.attributes.trend > 0:
                this.valueText = 'Vender';
                this.transaction.attributes.system1 = this.system.id;
                this.transaction.attributes.system2 = this.system.id === 'banco' ? 'palpal' : 'banco';

                return;

            default:
                this.valueText = 'Intercambiar';

                return;
        }
    }
}
